import styles from '@web/molecules/SimpleComment/SimpleComment.module.scss';

export interface Props {
    userName: string;
    userLikeCount?: number;
    AuthorIcon: null | React.ReactElement;
}

export const CommentHeader = ({ userName, AuthorIcon }: Props) => (
    <div className={styles['reply-header']}>
        <span className={styles['user-name']}>{userName}</span>
        {AuthorIcon ? <span className={styles['user-role']}>{AuthorIcon}</span> : null}
    </div>
);
